import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-col tw-gap-2.5" }
const _hoisted_2 = { class: "tw-flex tw-flex-1 tw-gap-5 tw-items-center tw-justify-end" }

import { getComponentUiText } from "@/utils/utilities";
import { SCANNING_TABLE_RESULT_ITEM_TYPE } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'cellTableResultsDetails',
  props: {
    isShowDetail: { type: Boolean },
    hasDetail: { type: Boolean },
    hasIgnore: { type: Boolean },
    type: {},
    className: {}
  },
  emits: ["update:show-detail", "update:ignore"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`tw-flex tw-flex-col tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded ${_ctx.className}`)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.hasDetail)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "tw-text-[12px] tw-font-normal tw-text-[#387DFF]",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:show-detail')))
          }, _toDisplayString(_ctx.isShowDetail
            ? _unref(getComponentUiText)(
                "app-scan-scanning-types-table-results-body-cell-unexpected-hide-details-1",
              )
            : _unref(getComponentUiText)(
                "app-scan-scanning-types-table-results-body-cell-unexpected-more-details-1",
              )), 1))
        : _createCommentVNode("", true),
      (_ctx.hasIgnore)
        ? (_openBlock(), _createBlock(_component_b_button, {
            key: 1,
            style: {
          width: `fit-content`,
        },
            variant: "primary",
            class: "tw-min-w-max tw-flex tw-items-center tw-justify-center tw-shadow-none tw-bg-white tw-text-[12px] tw-font-normal tw-text-[#387DFF] tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded-full tw-px-3 tw-py-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:ignore', _ctx.type)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
            _ctx.type === _unref(SCANNING_TABLE_RESULT_ITEM_TYPE).ignore
              ? "app-scan-scanning-types-table-results-body-cell-unexpected-ignore-1"
              : "app-scan-scanning-types-table-results-body-cell-unexpected-include-1",
          )), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})